(ns hai.tasks.eql
  "The task shape the composer and the task rows work with — the shape any host
   should resolve for a task it hands to them. Mirrors [[hai.notes.eql]].")

(def task-eql
  [:task/uuid
   :task/title
   :task/description
   :task/urgency
   :task/completed-at
   :task/deadline-at
   :task/deadline-all-day?
   :task/deadline-timezone
   :task/created-at
   :task/updated-at
   :task/assigned-to
   ;; Needed by `sharing/can-edit?` / `can-delete?` so a host knows which
   ;; controls to render.
   :user.entity/permissions
   {:task/activities [:activity/uuid :activity/url]}
   {:task/contacts [:contact/uuid :contact/full-name :contact/organisation?]}
   {:task/notes [:note/uuid :note/text]}
   {:task/tasks [:task/uuid :task/title]}
   ;; A tag carries its own permissions: `task/update` refuses to detach a tag
   ;; the requester isn't an admin of, so the chip must know whether to offer
   ;; a ✕ rather than let the save be rejected.
   {:task/tags [:group/uuid :group/display-name :user.entity/permissions]}])
